import React from 'react'
import "./OrderCard.css"
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
function OrderCard({order,status}) {
    const { currentLocal } = useSelector((state) => state.currentLocal);
    
    return (
        <div className='order_container'>
            <div className='d-flex justify-content-between mb-2'>
                <p className='mb-0 order_id'>{currentLocal.home.order} : {order&&order.order_no}</p>
                <p className='mb-0 date'>{order&&order.created_at?.substring(0,10)}</p>
            </div>

            <div className='d-flex mb-3'>

                <p className='mb-0 tracking_title'>{status==='proccessing'?"Status :": currentLocal.home.trackingNumber +':'} {order&&order.order_no}</p>
                <p className='mb-0 tracking_value'>{status==='proccessing'?order&&order.status==null?"Pending":order.status:order&&order.trackingNumber}</p>
            </div>
            <div className='d-flex justify-content-between mb-3'>
                <div className='d-flex justify-content-between'>
                    <p className='mb-0 Quantity_title'>{currentLocal.home.Quantity}:</p>
                    <p className='mb-0  Quantity_Value'> {order&&order?.quantity} </p>
                </div>


                <div className='d-flex '>
                    <p className='mb-0 total_title'>{currentLocal.home.total}:</p>
                    <p className='mb-0 total_value'>{order&&order.total} EGP</p>
                </div>

            </div>
            <Link className='details_btn'to={`/order/${order&&order.id}`}>
            {currentLocal.home.details}
            </Link>
        </div>
    )
}

export default OrderCard